// Index
// Features:
// - React/Three.js application entry point
// - Sets up Canvas, KeyboardControls, and global UI overlays

import './style.css'
import { Suspense } from 'react'
import ReactDOM from 'react-dom/client'
import * as THREE from 'three'
import { Canvas } from '@react-three/fiber'
import { KeyboardControls } from '@react-three/drei'
import { Leva } from 'leva'

import Experience from './Experience.jsx'
import Loader from './components/Loader/Loader.jsx'
import Hints from './components/ui/Hints.jsx'
import Crosshair from './components/ui/Crosshair.jsx'
import Links from './components/ui/Hints/Links.jsx'

const root = ReactDOM.createRoot(document.querySelector('#root'))

// Remove initial boot loader DOM (if present)
const boot = document.getElementById('boot-loader')
if (boot && boot.parentNode) boot.parentNode.removeChild(boot)
const bootCss = document.getElementById('boot-loader-style')
if (bootCss && bootCss.parentNode) bootCss.parentNode.removeChild(bootCss)

root.render(
    <>
        <Loader />
        <KeyboardControls
            map={[
                { name: 'w', keys: ['ArrowUp', 'KeyW'] },
                { name: 's', keys: ['ArrowDown', 'KeyS'] },
                { name: 'a', keys: ['ArrowLeft', 'KeyA'] },
                { name: 'd', keys: ['ArrowRight', 'KeyD'] },
                { name: 'jump', keys: ['Space'] },
                { name: 'c', keys: ['KeyC'] },
            ]}
        >
            <Leva hidden />

            {/* Global UI Layer */}
            <Hints />
            <Crosshair />
            <Links />

            {/* 3D Scene */}
            <Canvas
                shadows
                camera={{
                    fov: 60,
                    near: 0.1,
                    far: 200,
                    position: [9.131, 2.46, 14.627],
                }}
                gl={{
                    toneMapping: THREE.NoToneMapping,
                    outputColorSpace: THREE.SRGBColorSpace,
                }}
            >
                <color attach="background" args={['#000000']} />
                <Suspense fallback={null}>
                    <Experience />
                </Suspense>
            </Canvas>
        </KeyboardControls>
    </>
)
